import { Component, EventEmitter, Input, Output } from '@angular/core';
@Component({
    selector: 'kh-student-gap-box',
    templateUrl: './student-gap-box.component.html',
    styleUrls: ['./student-gap-box.component.less'],
    standalone: false
})
export class StudentGapBoxComponent {
  @Input() public studentPercentage!: number;
  @Input() public title!: string;
  @Output() studentGapBoxClicked = new EventEmitter<void>();
  @Output() public assignedClicked = new EventEmitter<void>();
  @Input() isAssigned: boolean = false;

  public onStudentGapBoxClick(): void {
    this.studentGapBoxClicked.emit();
  }

  public onLearnMore(event: Event): void {
    event.preventDefault();
  }
  

  public onAssignExtraPractice(event: Event): void {
    event.stopPropagation();
    if (!this.isAssigned) { // Prevent re-clicking once assigned
      this.assignedClicked.emit();
    }
  }

  public getBackgroundClass(): string {
    if (this.studentPercentage >= 50) {
      return 'bg-high-risk';
    } else if (this.studentPercentage >= 25) {
      return 'bg-moderate-risk';
    } else {
      return 'bg-low-risk';
    }
  }

}
